import forEach from 'lodash/forEach';
import template from 'lodash/template';
import { convertTimeToCTAndFormatPrint, formatTextWrap } from '@/views/history/history-utils';

const ticketTemplate = `CT~~CD,~CC^~CT~
^XA~TA000~JSN^LT0^MNN^MTD^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ
^XA
^MMT
^PW639
^LL{-{-{--}-}-}
^LS0
<% var height = 100; %>
^FO128,<%= (height) %>^GFA,06144,06144,00048,:Z64:
eJztlrFu5UQUho9jRZYSrUyD0mwYK+lCkZYGzXaUvADoPgM9kp2kSJlHICwFkVPkAYK4dytK7haIIAVsoIlSOYIIc+Pr4f/P+DqbbeIUFKA7xdF4/Pvz8ZlzzlhkOZZjOf69kdaxc66VELZ0NLhus5U8z09EaHdo1nK/IGm1CVEjm70+hZlEMHNZ5S0Lo1BXQ+8qw2nG1d/cwlRxv1iPaayuKl/1Yh/wqw3V81at12ahX/BpXvZ8//6J8jm7Un4JfTExBYaMYPY4+51mqosTC1PrzF+TX+qj+zRf9cb7q/69wU8y6umfC2gOaA5d7++E5kafpL4NpNfv9/qv7/mqv+r5rbzFD3v+lPy56n/tv7xZFQno5OkZpC+3tsJT586PMHOVnW1tI2h3+fmX6o9uQkz9JK0lgl6zw3IuQVrZCrf23FQXcY9OlF6PbY6hz3hrzDlfigdD6EvVt3Cb+vc8/0KiIiy67MNcgqIyU/I14mIusU2OmyCAlODvttveH76rTbAIf0LEq0wk6fnZt4IMnCAt4jbq9JzTn5R6vFz9abDyF3IMz0UIwhX4UXvP50tTz1/oBfM26PSlmCZiuEXmFebKv/30o3nHT/+UAPMmaBZ68H36eX/In41PEbTrPOn8OXB1qPw9QCz5Dhin/BBB435yvxvPx7dUEeaxBtm2vogD+kb+sSYR9bV+VOCQOGYGfhEgyOYyQnpfis4Z6ozlMOXihcgIe4ECmZgL8hlkq/6r41qYnl9FHb+SbXdsj7Hn0Ae9//QH/L48F/qUuZRZbj6iwSCn+mnkTzxf9fWCX/KG5XdATyYi0PO1HGRekD/XnuD1zxk86JmZeNNOfkZ+Jl25XedjNIlxz6/WQs5Noxp2lqi51wfuhZh6Q5OKQY7Ajjx/HRrtdLHnO1/J+HDwfVKRz8KomNthkTHC0F+KztlpwgL8iw0tCm5KhH2IiylrR/n0Z7fjt+dOy83Wtr33p0HgyG+Y+eo/EodzppyWs6lNp5+oPqXeNjGZrNNd6jG/0qBJz+emxAi2JrBp+FGqX/An8kzL7cMH/FbmVNna698/PR/Xnu/LwfN5poQ+SQ6c1xvtH4x6JRuuS+nIYaGymg8ocdzo9NjE1jc55xa9pysH30T9S8H/3vt/YTTtGXXwC7kvh5/RRJn/ETYF7d9p/x8zCKHnV+x8WgLtrl7f8zVpyU9rM9cmp3r9lkU5vKnXomC3gJNa3/5x05VAo/6XtvuoBX+ix12jTU4vN7sS8HqlVropyp+/oF5buNZTJrYrAX88SsdvF/zsIV98b2O5ef2G8hHwzn9sdn68cyIreeb/DnZOPF+P91rCh/z2ST8mb41k0NJ/b6xsJQmsTobojfsbtbvBkqmH6B30qN0ZtmCQflT8VPzCBmV4FAzh3zm37dokdXXyuBz/LbfORT8Wvv08Ptr8zLmj/aOs1d/PR/loSpXZlNVXnw+hSzCTqLZH++GrYdnp+SYIXjfD9Mj/ynxxeHAzUF/8EE3NaPTda+eG6FFiR5Udu7s//O/to3znPgY/vb1x/mdlAP/afWOru2F86J8598lm+Vk6iL8+y41rP7BltXM2hB+xqTbPTTmVaBCf+hb6UuJBfCb+dPOdd3GqDeHHsy2bH8dXttzaHcJHYxxlOKPM4bD4Qz/OQnc1PnL+D/txvQG/stET+OvozfEwPrCWhv9yA+Q4GvKdbC2/Pl7LB7Wfp44kSfQcSP4nx8FyLMdyLMdy6PgHbLCkCw==:750E
<% height += 170; %>

<% forEach(header, function(headerItem) {
  %>
  <% height += 30; %>
  ^FT38,<%= (height) %>^A0N,20,19^FH\^FD<%= headerItem %>^FS
  <%
})%>

<% if(deposit_code) { %>
  <% height += 120%>
  ^BY3,5^FT200,<%= height %>^B7N,5,0,,,N
  ^FH\^FD<%= deposit_code.toUpperCase() %>^FS
  <% height += 25%>
  ^FT159,<%= height %>^A0N,25,24^FH\^FD<%= deposit_code.toUpperCase() %>^FS
<% } %>

<% height += 70; %>
<% forEach(bets, function(row) {
  %>
  ^FO600,<%= (height) %>^GB0,75,8^FS
  ^FO25,<%= (height) %>^GB0,75,8^FS
  ^FO25,<%= (height) %>^GB580,0,1^FS
  ^FO25,<%= (height+75) %>^GB580,0,1^FS
  <% height += 30; %>
  ^FT38,<%= (height) %>^A0N,25,28^FH\^FD<%= row.CompleteDescription %>^FS
  ^FT<%= (key==='en'?380:350) %>,<%= (height) %>^A0N,25,28^FH\^FD<%= lang_bet_risk %>^FS
  ^FT450,<%= (height) %>^A0N,25,28^FH\^FD:<%= currency %> <%= parseFloat(row.OriginalRiskAmount).toFixed(2) %>^FS
  <% height += 25; %>
  ^FT38,<%= (height) %>^A0N,25,28^FH\^FD<%= (row.Detail.length) + ' ' + lang_bet %> @^FS
  ^FT<%= (key==='en'?380:350) %>,<%= (height) %>^A0N,25,28^FH\^FD<%= lang_bet_win %>^FS
  ^FT450,<%= (height) %>^A0N,25,28^FH\^FD:<%= currency %> <%= parseFloat(row.OriginalWinAmount).toFixed(2) %>^FS
  ^FO607,<%= (height) %>^GB0,30,1^FS
  ^FO25,<%= (height) %>^GB0,30,1^FS
  <% height += 30; %>
  <% forEach(row.Detail, function(detailRow) {
    %>
    ^FO607,<%= (height) %>^GB0,80,1^FS
    ^FO25,<%= (height) %>^GB0,80,1^FS
    <% height += 30; %>
    ^FT38,<%= (height) %>^A0N,20,17^FH\^FD<%= detailRow.DetailDescription %>^FS
    <% height += 20; %>
    ^FT38,<%= (height) %>^A0N,17,16^FH\^FD<%= convertTimeToCTAndFormatPrint(detailRow.GameDateTime, key) %>^FS
    <%
  })%>
  <% height += 30; %>
  ^FO25,<%= (height) %>^GB583,0,1^FS
  <% height += 32; %>
  <%
})%>

<% height += 30%>
^FT38,<%= height %>^A0N,23,26^FH^FD<%= lang_risk %>:^FS
^FT490,<%= height %>^A0N,23,26^FH^FD<%= currency %> <%= total_risk %>^FS

<% height += 30%>
^FT38,<%= height %>^A0N,23,26^FH^FD<%= lang_win %>:^FS
^FT490,<%= height %>^A0N,23,26^FH^FD<%= currency %> <%= total_win %>^FS

<% height += 30%>
^FT38,<%= height %>^A0N,23,26^FH^FD<%= lang_winTax %>:^FS
^FT490,<%= height %>^A0N,23,26^FH^FD<%= currency %> <%= winTax %>^FS


<% height += 50%>
^FT200,<%= height %>^A0N,25,28^FH^FD<%= time_stamp %>^FS
<% height += 120%>
^BY3,5^FT200,<%= height %>^B7N,5,0,,,N
^FH\^FD<%= barcode.toUpperCase() %>^FS
<% height += 25%>
^FT159,<%= height %>^A0N,25,24^FH\^FD<%= barcode.toUpperCase() %>^FS

<% height += 65; %>
^FT0,<%= (height) %>^A0N,36,30^FB600,1,0,C^FH\^FD<%= lang_warning %> ^FS
<% height += 40%>
<% forEach(terms, function(term) {
  %>
  ^FT38,<%= (height) %>^A0N,22,22^FH\^FD<%= term %>^FS
  <% height += 20; %>
  <%
})%>

<% height += 30; %>
^FT38,<%= (height) %>^A0N,22,22^FH^FD***************************************************^FS

<% forEach(footer, function(footerItem) {
  %>
  <% height += 30; %>
  ^FT38,<%= (height) %>^A0N,22,22^FH\^FD<%= footerItem %>^FS
  <%
})%>
<% height += 60; %>
^FT38,<%= (height) %>^A0N,22,22^FH^FD***************************************************^FS

<% height += 100%>
{_{_{_<%= height %>_}_}_}

^PQ1,0,1,Y^XZ`;

export function createWagerTicket(ticketJson) {
  const compiled = template(ticketTemplate);
  console.log(ticketJson.header);
  console.log(ticketJson.header);

  let d = compiled({
    header: ticketJson.header ? ticketJson.header.split('<br/>') : [],
    footer: ticketJson.footer ? ticketJson.footer.split('<br/>') : [],
    brand_description: ticketJson.brand_description,
    barcode: ticketJson.barcode,
    time_stamp: ticketJson.time_stamp,
    bets: ticketJson.bets,
    total_risk: ticketJson.total_risk,
    total_win: parseFloat(parseFloat(ticketJson.total_win) + parseFloat(ticketJson.total_risk)).toFixed(2),
    currency: ticketJson.currency,
    deposit_code: ticketJson.deposit_code,
    convertTimeToCTAndFormatPrint,
    lang_warning: ticketJson.lang_warning,
    lang_bet: ticketJson.lang_bet,
    lang_win: ticketJson.lang_win,
    lang_bet_win: ticketJson.lang_bet_win,
    lang_bet_risk: ticketJson.lang_bet_risk,
    lang_risk: ticketJson.lang_risk,
    key: ticketJson.key,
    winTax: ticketJson.winTax,
    winFee: ticketJson.winFee,
    lang_winTax: ticketJson.lang_winTax,
    lang_winFee: ticketJson.lang_winFee,
    terms: formatTextWrap(ticketJson.term, 70).split('\n'),
    forEach: forEach,
  });
  var heightFinder = /{_{_{_(\d+)_}_}_}/g;
  var match = heightFinder.exec(d);

  if (match != null) {
    var height = match[1];
    d = d.replace(heightFinder, '');
    d = d.replace(/LL{-{-{--}-}-}/g, 'LL' + height);
  }
  return d;
}
